var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PDF_DEFAULT_DPI } from "../constants";
import { uuidv4 } from "../util";
import { drawPageAsImage as drawPageOnCanvas, drawPageAsPng } from "./MuPdf/MupdfRenderer";
let gPdfManager = null;
const MAX_RENDERING_RETRY_COUNT = 16;
const DEGREE_DPI_RATIO = 0.9;
export class NeoPdfRendererManager {
    constructor() {
        this._currentJob = undefined;
        this._renderQueue = [];
        this.cancelJob = (id) => {
            if (this._currentJob.task.taskId === id) {
                const t = this._currentJob.task;
                t.canceled = true;
                t.resolve = undefined;
                t.reject(new Error(`current job cancelled - ${t.taskId}, job remained=${this._renderQueue.length}`));
                this.renderNext();
                return;
            }
            const jobIdx = this._renderQueue.findIndex((t) => t.task.taskId === id);
            if (jobIdx > -1) {
                const job = this._renderQueue[jobIdx];
                job.task.refCount--;
                if (job.task.refCount < 1) {
                    const t = job.task;
                    t.canceled = true;
                    t.resolve = undefined;
                    delete this._renderQueue[jobIdx];
                    this._renderQueue.splice(jobIdx, 1);
                    t.reject(new Error(`future job cancelled - ${t.taskId}, job remained=${this._renderQueue.length}`));
                    this.renderNext();
                }
            }
        };
        this.requestRenderPageAsync = (arg) => {
            const { page, renderContext, topPriority, type } = arg;
            let { dpi } = arg;
            dpi = Math.round(dpi);
            // 이전의 job이 있으면 그걸 return한다.
            const prevJob = this._renderQueue.find((j) => j.page === page && j.dpi === dpi);
            if (prevJob) {
                prevJob.task.refCount++;
                return prevJob.task;
            }
            // console.log(`rendering Request ${pageNum}`);
            let resolve = undefined;
            let reject = undefined;
            const pr = new Promise((rsv, rjt) => {
                resolve = rsv;
                reject = rjt;
            });
            const taskId = uuidv4();
            const cancel = () => {
                const inst = NeoPdfRendererManager.instance;
                inst.cancelJob(taskId);
            };
            const task = { promise: pr, resolve, reject, taskId, cancel, refCount: 1, canceled: false };
            const jobType = type || (renderContext ? "canvas" : "image");
            const job = { page, renderContext, task, dpi, jobType };
            console.log(`job queued dpi:${dpi}, ${taskId}`);
            if (topPriority) {
                this._renderQueue.unshift(job);
            }
            else {
                this._renderQueue.push(job);
            }
            this.renderNext();
            return task;
        };
        this._busyToRender = false;
        this.renderNext = () => __awaiter(this, void 0, void 0, function* () {
            const job = this._renderQueue[0];
            if (!job)
                return;
            if (job.jobType === "image")
                this.renderNextBackCanvas();
            else if (job.jobType === "png")
                this.renderNextPng();
            else
                this.renderNextCanvasDirect();
        });
        this.renderNextBackCanvas = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (this._busyToRender)
                return;
            const job = this._renderQueue.shift();
            if (!job)
                return;
            this._busyToRender = true;
            const { page, renderContext: r2, task } = job;
            let { dpi } = job;
            this._currentJob = job;
            const viewport = page.viewport;
            console.log(`rendering BackCanvas ${page === null || page === void 0 ? void 0 : page.pageNo} ${task.taskId}, dpi=${dpi}`);
            try {
                let success = false;
                let cnt = MAX_RENDERING_RETRY_COUNT;
                let canvas = null;
                let ctx = null;
                while (!success && cnt > 0) {
                    try {
                        canvas = document.createElement("canvas");
                        const scale = dpi / PDF_DEFAULT_DPI;
                        canvas.width = Math.round(viewport.width * scale);
                        canvas.height = Math.round(viewport.height * scale);
                        ctx = canvas.getContext('2d');
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        const renderContext = {
                            canvasContext: ctx,
                            transform: [scale, 0, 0, scale, 0, 0],
                            viewport: page.getViewport({
                                scale: 1,
                                rotation: viewport.rotation
                            }),
                            // intent: "print"
                        };
                        yield page._pdfPage.render(renderContext).promise;
                        success = true;
                        this._busyToRender = false;
                        console.log(`rendered ${page === null || page === void 0 ? void 0 : page.pageNo} ${task.taskId} - resolve:${!!task.resolve}, dpi=${dpi}, numJobs=${this._renderQueue.length}`);
                        (_a = task.resolve) === null || _a === void 0 ? void 0 : _a.call(task, {
                            canvas,
                            renderedDpi: dpi,
                            png: undefined,
                            renderedWidth: canvas.width,
                            renderedHeight: canvas.height
                        });
                        this.renderNext();
                    }
                    catch (e) {
                        console.error(`PdfJs Renderer: retry to draw page ${page.pageNo}, count: ${cnt} , dpi=${dpi}`);
                        ctx = null;
                        canvas = null;
                        dpi = Math.round(dpi * DEGREE_DPI_RATIO);
                        cnt--;
                        if (cnt === 0) {
                            throw e;
                        }
                    }
                }
                this._busyToRender = false;
            }
            catch (e) {
                this._busyToRender = false;
                task.reject(new Error(`rendering error(page:${page === null || page === void 0 ? void 0 : page.pageNo}), ${e}`));
                this.renderNext();
            }
        });
        this.renderNextPng = () => __awaiter(this, void 0, void 0, function* () {
            var _b;
            if (this._busyToRender)
                return;
            const job = this._renderQueue.shift();
            if (!job)
                return;
            this._busyToRender = true;
            const { page, task, } = job;
            let { dpi } = job;
            this._currentJob = job;
            console.log(`rendering PNG ${page === null || page === void 0 ? void 0 : page.pageNo} ${task.taskId}, dpi=${dpi}`);
            const viewport = page.viewport;
            try {
                let success = false;
                let cnt = MAX_RENDERING_RETRY_COUNT;
                while (!success && cnt > 0) {
                    try {
                        // const u = await page._pdfPage.render(renderContext).promise;
                        const scale = dpi / PDF_DEFAULT_DPI;
                        const renderedWidth = Math.round(viewport.width * scale);
                        const renderedHeight = Math.round(viewport.height * scale);
                        const imageData = yield drawPageAsPng(page._doc, page.pageNo, dpi);
                        this._busyToRender = false;
                        success = true;
                        console.log(`rendered ${page === null || page === void 0 ? void 0 : page.pageNo} ${task.taskId} - resolve:${!!task.resolve}, dpi=${dpi}, numJobs=${this._renderQueue.length}`);
                        (_b = task.resolve) === null || _b === void 0 ? void 0 : _b.call(task, {
                            canvas: undefined,
                            renderedDpi: dpi,
                            png: imageData,
                            renderedWidth,
                            renderedHeight
                        });
                        this.renderNext();
                    }
                    catch (e) {
                        dpi = Math.round(dpi * DEGREE_DPI_RATIO);
                        console.error(`MuPdf Renderer: retry to draw page ${page.pageNo}, count: ${cnt} , dpi=${dpi}`);
                        cnt--;
                        if (cnt === 0) {
                            throw e;
                        }
                    }
                }
            }
            catch (e) {
                this._busyToRender = false;
                task.reject(new Error(`rendering error(page:${page === null || page === void 0 ? void 0 : page.pageNo}), ${e}, `));
                this.renderNext();
            }
        });
        this.renderNextCanvasDirect = () => __awaiter(this, void 0, void 0, function* () {
            var _c;
            if (this._busyToRender)
                return;
            const job = this._renderQueue.shift();
            if (!job)
                return;
            this._busyToRender = true;
            const { page, renderContext, task, dpi } = job;
            this._currentJob = job;
            console.log(`rendering Canvas direct ${page === null || page === void 0 ? void 0 : page.pageNo} ${task.taskId}, dpi=${dpi}`);
            const viewport = page.viewport;
            try {
                // const u = await page._pdfPage.render(renderContext).promise;
                const scale = dpi / PDF_DEFAULT_DPI;
                const renderedWidth = Math.round(viewport.width * scale);
                const renderedHeight = Math.round(viewport.height * scale);
                const imageData = yield drawPageOnCanvas(page._doc, page.pageNo, dpi);
                const ctx = renderContext.canvasContext;
                ctx.putImageData(imageData, 0, 0);
                console.log(`rendered ${page === null || page === void 0 ? void 0 : page.pageNo} ${task.taskId} - resolve:${!!task.resolve}, dpi=${dpi}, numJobs=${this._renderQueue.length}`);
                this._busyToRender = false;
                (_c = task.resolve) === null || _c === void 0 ? void 0 : _c.call(task, {
                    canvas: renderContext.canvas,
                    renderedDpi: dpi,
                    png: undefined,
                    renderedHeight, renderedWidth
                });
                this.renderNext();
            }
            catch (e) {
                this._busyToRender = false;
                console.error(`PdfJs Renderer: retry to draw page ${page.pageNo}, dpi=${dpi}`);
                this.renderNext();
            }
        });
    }
    static getInstance() {
        if (gPdfManager)
            return gPdfManager;
        gPdfManager = new NeoPdfRendererManager();
        return gPdfManager;
    }
    static get instance() {
        return NeoPdfRendererManager.getInstance();
    }
}
//# sourceMappingURL=NeoPdfRendererManager.js.map